import { useState } from "react";
import "./faqOfHrms.css";
import { Helmet } from "react-helmet";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const faqData = [
    {
        question: "What is an HRMS and why do businesses need it?",
        answer:
            "An HRMS (Human Resource Management System) plays a crucial role in streamlining business operations by automating key functions such as payroll, attendance tracking, leave management, and overall employee management.",
    },
    {
        question: "How does HRMS improve payroll management?",
        answer:
            "HRMS enhances payroll management by accurately automating salary calculations, deductions, bonuses, and statutory compliance",
    },
    {
        question: "Can HRMS track attendance and working hours?",
        answer:
            "Yes, it tracks real-time attendance, shifts, overtime, and integrates directly with payroll.",
    },
    {
        question: "How does leave management system help HR and managers?",
        answer:
            "A leave management system helps HR automate and centralize the process of managing employee leaves. It simplifies the leave workflows for managers as their staff can apply for leave from their ESS portal, while they can approve them instantly using their ESS portal.",
    },
       {
        question: "Does leave management system support customizable leave types?",
        answer:
            "Yes, the leave management system supports different leave types as they are developed to cater to different kinds of organizations. Hence, the company deploying the system can set its custom rules for each kind of leave, making them extremely flexible",
    },
     {
        question: "Can employees see their leave history and balance?",
        answer:
            "Yes, employees can see their leave history and balances using the dedicated ESS portal. This portal proves to be a game-changer for HR teams as employees can view their leave balance, apply for specific kinds of leaves, as well as track their approval status from their ESS portals, without disturbing HR.",
    },
    {
        question: "Is HRMS suitable for small and growing businesses?",
        answer:
            "Yes, HRMS is scalable and flexible for businesses of all sizes.",
    },
    {
        question: "How secure is employee data in HRMS?",
        answer:
            "HRMS uses role-based access and secure data encryption to protect employee information.",
    },
    {
        question: "Does HRMS provide reports and analytics?",
        answer:
            "Yes, it offers real-time dashboards and detailed HR reports for better decision-making.",
    },
    {
        question: "Can HRMS integrate with other systems?",
        answer:
            "HRMS integrates seamlessly with ERP, accounting software, and biometric devices.",
    },
];

const FaqOfHrms = () => {
    const [activeIndex, setActiveIndex] = useState(0); // default open

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <>
            <Helmet>
                <title>
                    HRMS Software FAQs | HR Management System Questions | TechCognics
                </title>

                <meta
                    name="description"
                    content="Find answers to common HRMS software questions. Learn how HR software helps manage payroll, attendance, compliance, and employee records efficiently."
                />

                <meta
                    name="keywords"
                    content="HRMS FAQs, HR software questions, HR management system FAQ, HRMS software help, HR automation FAQ, payroll HRMS questions"
                />

                <meta
                    property="og:title"
                    content="HRMS Software FAQs | HR Management System Questions"
                />

                <meta
                    property="og:description"
                    content="Get clear answers to frequently asked questions about HRMS software, payroll automation, attendance tracking, and HR compliance."
                />

                <meta property="og:type" content="website" />
            </Helmet>
            <section className="faq__three section-padding">
                <div className="container  border faq-hover">
                    <div >
                        {/* Heading */}
                        <div className="site-heading text-center mb-4">
                            <div className="tcn-sectionTitle feature-heading" style={{ fontSize: 'clamp(18px, 2vw, 24px)',color: '#0F4F93' }} >
                                <HelpOutlineIcon className="mb-1 me-2" sx={{ color: "#2563eb", fontSize: 25 }} />
                                FAQs on HRMS Software</div>

                            <p>
                                Everything you need to know about using our HR software effectively.
                            </p>
                        </div>
                
                        <div className="row ">
                            {faqData.map((item, index) => (
                                <div className="col-lg-12 order-2 order-lg-1 justify-content-md-center justify-content-lg-end " key={index} >
                                    <Accordion
                                        expanded={activeIndex === index}
                                        onChange={() =>
                                            setActiveIndex(activeIndex === index ? null : index)
                                        }
                                        
                                        className="faq-collapse-item mb-1"
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor:
                                                    activeIndex === index ? "aliceblue" : "transparent",
                                            }}
                                            aria-controls={`faq-content-${index}`}
                                            id={`faq-header-${index}`}
                                        >
                                            <h6 className="mb-0">{item.question}</h6>
                                        </AccordionSummary>

                                        <AccordionDetails className="faq-content">
                                            <p class="text-start">{item.answer}</p>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>

                            ))}
                        </div>

                    </div>
                </div>
            </section>

        </>

    );
};

export default FaqOfHrms;
